import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Home } from "./containers";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

const App = () => {

  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
  )
};

export default App;
